import { initialDateFormat } from 'shared/types/date-format-options';
import { User } from 'shared/types/user';

export const getDateFormat = (user?: User | null) =>
  user?.settings?.dateFormat ?? initialDateFormat;
